import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux'

export default () => {

    const { isAuthenticated } = useSelector(state => state.auth);
    const { blueXPShellLoaded } = useSelector(state => state.tenancy);
    

    const isAuthenticatedref = useRef(null);
    const isblueXPShellLoadedref = useRef(null);

    useEffect(() => {
        const timestamp = new Date().toString();

        if(isAuthenticatedref.current && isAuthenticatedref.current.value === "") {
            isAuthenticatedref.current.value = `${timestamp}`;
        }

        if(isblueXPShellLoadedref.current && isblueXPShellLoadedref.current.value === "") {
            isblueXPShellLoadedref.current.value = `${timestamp}`;
        }

    }, [isAuthenticated, blueXPShellLoaded])

    return <form style={{display: "none"}} >
        {isAuthenticated && <input type="hidden" id="user-authenticated" ref={isAuthenticatedref}/>}
        {blueXPShellLoaded && <input type="hidden" id="blueXPShell-loaded" ref={isblueXPShellLoadedref}/>}
    </form>
}

export const PerformanceLogger = ({id, isLoaded}) => {
    const isLoadedref = useRef(null);

    useEffect(() => {
        const timestamp = new Date().toString();

        if(isLoadedref.current && isLoadedref.current.value === "") {
            isLoadedref.current.value = `${timestamp}`;
        }

    }, [isLoaded])

    return <form style={{display: "none"}} >
        {isLoaded && <input type="hidden" id={id} ref={isLoadedref}/>}
    </form>
}